import { Box, Grow, Skeleton as MuiSkeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

function WriteWithAISkeleton() {
  return (
    <>
      <Box>
        <Grow in timeout={2000}>
          <Skeleton
            animation="wave"
            variant="text"
            width="100%"
            height={10}
            sx={(theme) => ({ my: 1, backgroundColor: theme.palette.custom.skelton1 })}
          />
        </Grow>
        <Grow in timeout={3000}>
          <Skeleton
            animation="wave"
            variant="text"
            width="100%"
            height={10}
            sx={(theme) => ({ my: 1, backgroundColor: theme.palette.custom.skelton1 })}
          />
        </Grow>
        <Grow in timeout={3500}>
          <Skeleton
            animation="wave"
            variant="text"
            width="90%"
            height={10}
            sx={(theme) => ({ my: 1, backgroundColor: theme.palette.custom.skelton1 })}
          />
        </Grow>
      </Box>
      <Box mt={2}>
        <Grow in timeout={2000}>
          <Skeleton
            animation="wave"
            variant="text"
            width="100%"
            height={10}
            sx={(theme) => ({ my: 1, backgroundColor: theme.palette.custom.skelton1 })}
          />
        </Grow>
        <Grow in timeout={3000}>
          <Skeleton
            animation="wave"
            variant="text"
            width="100%"
            height={10}
            sx={(theme) => ({ my: 1, backgroundColor: theme.palette.custom.skelton1 })}
          />
        </Grow>
        <Grow in timeout={3500}>
          <Skeleton
            animation="wave"
            variant="text"
            width="90%"
            height={10}
            sx={(theme) => ({ my: 1, backgroundColor: theme.palette.custom.skelton1 })}
          />
        </Grow>
      </Box>
    </>
  );
}

const Skeleton = styled(MuiSkeleton, { label: 'Skeleton' })({
  '&::after': {
    background: `linear-gradient(
      90deg,
      transparent,
      rgb(143 143 143 / 80%),
      transparent
    )`,
  },
});

export default WriteWithAISkeleton;
